"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderSelector = void 0;
var fp = require("fp-ts");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var FolderSelector = function (props) {
    var optionsList = props.folderList
        .sort(function (a, b) { return a.name.localeCompare(b.name); })
        .map(function (folder) {
        return {
            leftComponent: React.createElement(Icon_1.Icon, { className: "fa-folder" }),
            value: folder.id,
            text: folder.name
        };
    });
    var options = [
        {
            text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/limitToFolder/placeHolder/any'),
            value: -1
        }
    ].concat(optionsList);
    var selected = options.find(function (x) {
        return props.limitSearchToFolder &&
            props.limitSearchToFolder.fold(false, function (value) { return x.value === value; });
    });
    return (React.createElement("div", { className: 'sok-form-field text' },
        React.createElement("div", { className: 'input' },
            React.createElement("label", null, (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/limitToFolder')),
            React.createElement(sok_ui_1.Dropdown2, { isOpen: props.isOpen, onChange: function (value) {
                    props.toggle(value);
                }, alignment: 'center' },
                React.createElement("div", { className: 'dropdown-input' },
                    React.createElement("input", { type: 'text', placeholder: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/limitToFolder/placeHolder/any'), value: selected ? selected.text : '' }),
                    React.createElement(Icon_1.Icon, { className: 'fa-caret-down' })),
                React.createElement(sok_ui_1.Dropdown2Menu, { className: 'narrow sok-click-wall' }, options.map(function (item, index) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: index, onClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        props.toggle();
                        if (item.value === -1) {
                            return props.onLimitToFolder(fp.option.none);
                        }
                        return props.onLimitToFolder(fp.option.some(item.value));
                    } },
                    React.createElement("div", { className: selected && selected.value === item.value ? 'active' : '' },
                        React.createElement("span", { style: { marginRight: '0.8rem' } }, item.leftComponent),
                        React.createElement("label", null, item.text)))); }))))));
};
exports.FolderSelector = FolderSelector;
